<script>
import Tab1Require from '@/views/pages/require/components/tab1.vue';
import Tab2Require from '@/views/pages/require/components/tab2.vue';
import Tab3Require from '@/views/pages/require/components/tab3.vue';
import Tab4Require from '@/views/pages/require/components/tab4.vue';
import Tab5Require from '@/views/pages/require/components/tab5.vue';
import Tab6Require from '@/views/pages/require/components/tab6.vue';
import Tab7Require from '@/views/pages/require/components/tab7.vue';
import Tab8Require from '@/views/pages/require/components/tab8.vue';
import Tab9Require from '@/views/pages/require/components/tab9.vue';
import Tab10Require from '@/views/pages/require/components/tab10.vue';
import Tab11Require from '@/views/pages/require/components/tab11.vue';
import TabContentDynamic from '@/views/pages/require/components/TabContentDynamic.vue';
import InfoCampaign from '@/views/pages/require/components/InfoCampaign.vue';

import { masterMethods } from '@/state/helpers';
import { getComponent, getDynamicProps, toggleCommonSwitch, isRolePartner, isPermissionPartnerEdit } from '@/views/pages/require/handlers';
import { checkPermissionName } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';

export default {
    name: 'RequireTabs',
    components: {
        Tab1Require,
        Tab2Require,
        Tab3Require,
        Tab4Require,
        Tab5Require,
        Tab6Require,
        Tab7Require,
        Tab8Require,
        Tab9Require,
        Tab10Require,
        Tab11Require,
        TabContentDynamic,
        InfoCampaign
    },
    props: {
        listSheets: {
            type: Array,
            default: () => []
        },
        detailBeginForDocument: {
            type: Object,
            default: () => ({})
        },

        configTabContentDynamic: {
            type: Function,
            required: true
        },
        currentUser: {
            type: Object,
            default: () => ({})
        },
        check1: {
            type: Boolean,
            default: false
        },
        check2: {
            type: Boolean,
            default: false
        },
        check3: {
            type: Boolean,
            default: false
        },
        check4: {
            type: Boolean,
            default: false
        },
        checkOrder: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({})
        },
        isPreview: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modelTab: 0,
            isRolePartner: isRolePartner(),
            isPermissionPartnerEdit: isPermissionPartnerEdit(),
            processingFields: {}
        };
    },
    watch: {
        modelTab() {
            this.$nextTick(() => {
                window.dispatchEvent(new CustomEvent('resize-textarea'));
            });
        }
    },
    methods: {
        ...masterMethods,
        getComponent,
        getDynamicProps,
        checkPermissionName,
        toggleCommonSwitch,

        isAllActiveComputed() {
            if (this.listSheets?.length <= 0) return false;
            return this.listSheets.every((item) => item.is_active === true);
        },

        handleToggleSwitch(val, tab) {
            if (!tab.is_permanent) {
                if (this.data.partner_request_free_sheet) {
                    const item = this.data.partner_request_free_sheet.find((i) => i.sheet === tab.name);
                    if (item) {
                        this.$set(item, 'is_active', val);
                    }
                }
            } else {
                this.toggleCommonSwitch(val, { [tab.key]: this.data[tab.key] });
            }
        },

        onHandleDeleteTab(id) {
            this.$emit('delete-tab', id);
        },
        onHandleAddTab() {
            this.$emit('add-tab');
        },

        async tabCheckBoxValueHandle({ payload, fieldName, type, index }) {
            const processingKey = index !== undefined ? `${fieldName}_${index}_${type}` : `${fieldName}_${type}`;
            if (!this.data?.id || (this.processingFields && this.processingFields[processingKey])) return;
            this.$set(this.processingFields, processingKey, true);
            try {
                const resData = await this.updateCheckValuePartnerRequestSheet({ campaign_id: this.detailBeginForDocument.id, ...payload });
                if (!resData?.code || resData?.code !== 200) {
                    showMessage(resData.code, this.$bvToast, 'Thất bại');
                }
                this.$set(this.processingFields, processingKey, false);
            } catch (error) {
                showMessage(error?.code, this.$bvToast, 'Thất bại');
                this.$set(this.processingFields, processingKey, false);
            }
        }
    }
};
</script>

<template>
    <div class="custom-screen-14">
        <b-tabs v-if="isAllActiveComputed()" vertical justified nav-class="tab-info-campaign" content-class="px-3">
            <b-tab class="border-0">
                <template v-slot:title> </template>
                <InfoCampaign :detailBeginForDocument="detailBeginForDocument" />
            </b-tab>
        </b-tabs>
        <b-tabs vertical justified nav-class="nav-tabs-custom tabs_landing--page" content-class="p-3 text-muted scroll--content" v-model="modelTab">
            <b-tab v-for="tab in listSheets" :key="tab.make_id" class="border-0">
                <template v-slot:title>
                    <div class="d-flex">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            v-model="tab.is_active"
                            :name="`check-${tab.make_id}`"
                            switch
                            @click.native.stop
                            @change="handleToggleSwitch($event, tab)"
                        />
                        <div class="text-truncate pr-1" style="width: 210px" v-b-tooltip.hover :title="tab.name">
                            {{ tab.name }}
                        </div>
                        <div v-if="!tab.is_permanent && !isPreview && !isRolePartner && isPermissionPartnerEdit" class="ml-auto">
                            <button type="button" class="btn btn-sm btn-danger rounded-circle" @click.prevent="onHandleDeleteTab(tab.make_id)">
                                <i class="fa fa-minus"></i>
                            </button>
                        </div>
                    </div>
                </template>
                <component
                    :is="getComponent(tab)"
                    v-bind="
                        getDynamicProps(
                            tab,
                            configTabContentDynamic,
                            detailBeginForDocument,
                            currentUser,
                            check1,
                            check2,
                            check3,
                            check4,
                            checkOrder,
                            data,
                            isPreview,
                            processingFields
                        )
                    "
                    @handleTabCheckBoxValue="tabCheckBoxValueHandle"
                />
            </b-tab>
            <template
                v-if="
                    checkPermissionName(['administrator', 'sale', 'instructor', 'part_time']) &&
                    !isPreview &&
                    !isRolePartner &&
                    isPermissionPartnerEdit
                "
                #tabs-end
            >
                <li class="nav-item text-left py-2 pl-3">
                    <button type="button" class="btn btn-sm btn-success rounded-circle" @click.prevent="onHandleAddTab">
                        <i class="fa fa-plus"></i>
                    </button>
                </li>
            </template>
        </b-tabs>
    </div>
</template>

<style lang="scss">
.custom-screen-14 {
    .tab-info-campaign {
        opacity: 0;
        visibility: hidden;
    }
    .nav-item {
        width: 280px;
    }
}
</style>
